import React from "react";
import "./sidemodal.scss";

const Sidemodal = ({ isOpen, onClose, children, sidewidth }) => {
  return (
    <div
      className={`aq-sidebar ${isOpen ? "open" : "close"}`}
      style={{ width: sidewidth || "20rem" }}
    >
      <div className="aq-sidebar-overlay" onClick={onClose}></div>

      <div
        className="aq-sidebar-content"
        style={{ width: sidewidth || "20rem" }}
      >
        <button className="close-btn" onClick={onClose}>
          ×
        </button>

        {/* Your custom HTML / JSX */}
        {children}
      </div>
    </div>
  );
};

export default Sidemodal;
